import * as PropTypes from 'prop-types';
import * as React from 'react';
import { get, isEmpty } from 'lodash';
import * as classNames from 'classnames';
import { Link } from 'react-router';
import AffirmBanner from './affirm_banner';
import SaleInformation from './sales/sale_information';
import CollectionHeaderEditButton from './collection_header_edit_button';
import CollectionHeaderRenameButton from './collection_header_rename_button';
import { CollectionHeaderStore } from './stores/collection_header_store';
import UserStore from '../../reverb-js-common/user_store';

const USA = 'US';

class CollectionHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = CollectionHeaderStore.getState();
    this.onCollectionHeaderStoreUpdated = this.onCollectionHeaderStoreUpdated.bind(this);
  }

  componentDidMount() {
    CollectionHeaderStore.listen(this.onCollectionHeaderStoreUpdated);
  }

  componentWillUnmount() {
    CollectionHeaderStore.unlisten(this.onCollectionHeaderStoreUpdated);
  }

  onCollectionHeaderStoreUpdated() {
    this.setState(CollectionHeaderStore.getState());
  }

  get fullBleedImage() {
    return get(
      this.state,
      'collectionHeader._links.full_bleed_header_image.href',
    );
  }

  get headerImage() {
    return get(
      this.state,
      'collectionHeader._links.header_image.href',
    );
  }

  get backgroundImage() {
    if (!this.fullBleedImage) return null;

    return { style: { backgroundImage: `url('${this.fullBleedImage}')` } };
  }

  get isLoaded() {
    return !isEmpty(this.state.collectionHeader);
  }

  get isSale() {
    return !!this.state.collectionHeader.sale;
  }

  get isAffirmPromotion() {
    return !!this.props.affirmPromotionMonths || !!this.state.collectionHeader.affirm_promotion;
  }

  get affirmPromotion() {
    if (!this.isAffirmPromotion) { return null; }

    return this.state.collectionHeader.affirm_promotion;
  }

  get affirmPromotionMonths() {
    return this.props.affirmPromotionMonths || this.affirmPromotion.months;
  }

  get isBrandPage() {
    if (this.props.params) {
      return !!this.props.params.brand_slug;
    }
    return false;
  }

  get adminButtonSlug() {
    if (this.isBrandPage) {
      return get(this.props, 'params.brand_slug');
    }
    return get(this.props, 'params.curated_set_slug');
  }

  get title() {
    return this.props.titleOverride ||
      get(this.state, 'collectionHeader.title');
  }

  hasDescription() {
    return !!this.state.collectionHeader.description;
  }

  renderHeaderImage() {
    if (this.props.hideBanner || !this.headerImage) { return null; }

    return (
      <div className="collection-header__title__banner">
        <img role="presentation" src={this.headerImage} />
      </div>
    );
  }

  renderFineprint() {
    if (!this.isSale) { return null; }

    const descriptionHTML = get(this.state, 'collectionHeader.description');

    return (
      <SaleInformation
        sale={this.state.collectionHeader.sale}
        description={descriptionHTML}
        socialLinks={get(this.state, 'collectionHeader._links.social')}
        location={this.props.location}
      />
    );
  }

  renderHeaderButtons() {
    return (
      <div className="collection-header__buttons">
        {this.renderHeaderEditButton()}
        {this.renderHeaderRenameButton()}
      </div>
    );
  }

  renderHeaderEditButton() {
    return (
      <CollectionHeaderEditButton
        isSale={this.isSale}
        slug={this.adminButtonSlug}
        isBrandPage={this.isBrandPage}
      />
    );
  }

  renderHeaderRenameButton() {
    if (!this.isBrandPage) { return null; }
    return (
      <CollectionHeaderRenameButton
        slug={this.adminButtonSlug}
      />
    );
  }

  renderAffirmBanner() {
    const shouldShowBanner = this.isAffirmPromotion && UserStore.getState().countryCode === USA;

    if (!shouldShowBanner) { return null; }

    return (
      <AffirmBanner months={this.affirmPromotionMonths} />
    );
  }

  renderHeader() {
    if (this.props.headerLinkTarget) {
      return (
        <h1 className="collection-header__title__text">
          <Link
            to={this.props.headerLinkTarget}
            className="collection-header__title__link"
          >
            {this.title}
          </Link>
        </h1>
      );
    }

    return (
      <h1 className="collection-header__title__text">
        {this.title}
      </h1>
    );
  }

  renderSubtitle() {
    if (!this.props.subtitle) { return null; }

    return (
      <h2 className="collection-header__subtitle">
        {this.props.subtitle}
      </h2>
    );
  }

  render() {
    if (!this.isLoaded) { return null; }

    const classes = classNames(
      'collection-header',
      { 'collection-header--with-subtitle': this.props.subtitle },
      { 'collection-header--with-image': !!this.fullBleedImage },
      { 'collection-header--with-description': this.hasDescription() },
    );

    return (
      <div className={classes}>
        <header
          className="collection-header__title"
          {...this.backgroundImage}
        >
          {this.renderHeaderImage()}
          {this.renderHeader()}
          {this.renderSubtitle()}
        </header>
        {this.renderAffirmBanner()}
        {this.renderFineprint()}
        {this.renderHeaderButtons()}
      </div>
    );
  }
}

CollectionHeaderComponent.propTypes = {
  params: PropTypes.object,
  hideBanner: PropTypes.bool,
  titleOverride: PropTypes.string,
  subtitle: PropTypes.string,
  headerLinkTarget: PropTypes.string,
  location: PropTypes.object,
  affirmPromotionMonths: PropTypes.array,
};

CollectionHeaderComponent.defaultProps = {
  hideBanner: false,
};

export default CollectionHeaderComponent;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/collection_header_component.jsx